import * as React from 'react';
import { useIntl } from 'react-intl';
import messages from './messages.json';

type Translate = (
  definedMessage: string | Array<string> | { id: string; defaultMessage?: string },
  values: Object | void,
) => React.ReactNode;

declare global {
  interface Window {
    CART_CHECK_I18N?: boolean;
  }
}

const translate =
  (intl) =>
  (definedMessage, values): Translate => {
    const id = typeof definedMessage === 'object' ? definedMessage.id : definedMessage;
    if (
      (process.env.NODE_ENV === 'development' || window.CART_CHECK_I18N === true) &&
      !messages[id]
    ) {
      throw new Error(`Missing I18N message: ${id}`);
    }
    return intl.formatMessage(typeof definedMessage === 'object' ? definedMessage : { id }, values);
  };

const IntlConsumer = ({ children }: { children: (t: any) => React.ReactNode }) => {
  const intl = useIntl();
  return <>{children(translate(intl))}</>;
};

export const Intl = IntlConsumer;
const t: Translate = (definedMessage, values) => (
  <Intl>{(intl) => intl(definedMessage, values)}</Intl>
);

export default t;
